import { Link, useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import '../App.css';

const Header2 = ({ type }) => {
    const pathname = window.location.pathname;
    const navigate = useNavigate();
    
    return (
        <nav className="modern-header2" style={{ marginTop: isMobile ? "28px" : "" }}>
            <div className="header2-content">
                <Link className="header2-back" onClick={() => navigate(-1)}>
                    <i className='lni lni-arrow-left'></i>
                </Link>
                <div className="header2-title">
                    {type}
                </div>
                <a href={pathname} className="header2-reload">
                    <i className='lni lni-reload'></i>
                </a>
            </div>
        </nav>
    );
}

export default Header2;